module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-submit-btn.56a4ed62.svg";